import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  sort15ai02l4kxbfa as sort,
} from '../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  coerceIn1xblvmyr0tby6 as coerceIn,
} from '../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { to2cs3ny02qtbcb as to } from '../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { Assign2nr5v5j409ffp as Assign } from '../../../lightning-server-shared/com/lightningkite/lightningdb/Modification.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toMutableList20rdgwi7d3cwi as toMutableList,
  getOrNull1go7ef9ldk0df as getOrNull,
} from '../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { get_lastIndex1yw0x4k50k51w as get_lastIndex } from '../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  get_serializableProperties2tbouuwr11am9 as get_serializableProperties,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function createReorderMods(_this__u8e3s4, serializer, fromIdx, toIdx) {
  // Inline function 'kotlin.collections.associate' call
  var this_0 = reorder(_this__u8e3s4, fromIdx, toIdx);
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination = LinkedHashMap().fc(capacity);
  var _iterator__ex2g4s = this_0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    // Inline function 'kotlin.collections.plusAssign' call
    var pair = to(element.h40(), element.k8v());
    destination.s3(pair.af_1, pair.bf_1);
  }
  var reordered = destination;
  var path = order(new (DataClassPathSelf())(serializer));
  var mods = HashMap().n8();
  var _iterator__ex2g4s_0 = _this__u8e3s4.m1();
  $l$loop_0: while (_iterator__ex2g4s_0.n1()) {
    var item = _iterator__ex2g4s_0.o1();
    var tmp0_elvis_lhs = reordered.p3(item.h40());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      continue $l$loop_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var newOrder = tmp;
    if (newOrder === item.k8v())
      continue $l$loop_0;
    var tmp2 = item.h40();
    // Inline function 'kotlin.collections.set' call
    var value = path.f44(Assign().n42(newOrder));
    mods.s3(tmp2, value);
  }
  return mods;
}
function compareTo_0(other) {
  return compareTo(this.k8v(), other.k8v());
}
var ReorderableClass;
function Reorderable() {
  if (ReorderableClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Reorderable', VOID, VOID, [Comparable()]);
    ReorderableClass = $;
  }
  return ReorderableClass;
}
function reorder(_this__u8e3s4, fromIdx, toIdx) {
  // Inline function 'kotlin.apply' call
  var this_0 = toMutableList(_this__u8e3s4);
  reorder_0(this_0, fromIdx, toIdx);
  return this_0;
}
function order(_this__u8e3s4) {
  return _this__u8e3s4.prop(get_order(_this__u8e3s4.j2j()));
}
function reorder_0(_this__u8e3s4, fromIdx, toIdx) {
  if (fromIdx === toIdx)
    return Unit_instance;
  // Inline function 'kotlin.require' call
  if (!(0 <= fromIdx ? fromIdx <= (_this__u8e3s4.p1() - 1 | 0) : false)) {
    var message = 'fromIdx must be within the list to reorder';
    throw IllegalArgumentException().a1(toString(message));
  }
  sort(_this__u8e3s4);
  var iterator = _this__u8e3s4.m1();
  var index = 0;
  while (iterator.n1()) {
    var idx = index;
    index = index + 1 | 0;
    var item = iterator.o1();
    if (item.k8v() <= 0.0 || item.k8v() >= 1.0) {
      replace(_this__u8e3s4, idx, reorder$lambda);
    }
  }
  var pos = toIdx > fromIdx ? toIdx : toIdx - 1 | 0;
  var before = getOrNull(_this__u8e3s4, pos);
  // Inline function 'kotlin.run' call
  var tmp$ret$2;
  $l$block_0: {
    var tmp0_elvis_lhs = getOrNull(_this__u8e3s4, pos + 1 | 0);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      tmp$ret$2 = null;
      break $l$block_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var immediatelyAfter = tmp;
    var tmp_0 = immediatelyAfter.k8v();
    if (!(tmp_0 === (before == null ? null : before.k8v()))) {
      tmp$ret$2 = immediatelyAfter;
      break $l$block_0;
    }
    var sub = _this__u8e3s4.m3(pos + 1 | 0, _this__u8e3s4.p1());
    var tmp$ret$4;
    $l$block_1: {
      // Inline function 'kotlin.collections.indexOfFirst' call
      var index_0 = 0;
      var _iterator__ex2g4s = sub.m1();
      while (_iterator__ex2g4s.n1()) {
        var item_0 = _iterator__ex2g4s.o1();
        if (!(item_0.k8v() === before.k8v())) {
          tmp$ret$4 = index_0;
          break $l$block_1;
        }
        index_0 = index_0 + 1 | 0;
      }
      tmp$ret$4 = -1;
    }
    // Inline function 'kotlin.takeUnless' call
    var this_0 = tmp$ret$4;
    var tmp_1;
    if (!(this_0 === -1)) {
      tmp_1 = this_0;
    } else {
      tmp_1 = null;
    }
    var nextHighestIdx = tmp_1;
    var nextHighest = nextHighestIdx == null ? 1.0 : sub.q1(nextHighestIdx).k8v();
    var tmp_2 = nextHighest - before.k8v();
    var step = tmp_2 / ((nextHighestIdx == null ? get_lastIndex(sub) : nextHighestIdx) + 2 | 0);
    var inductionVariable = nextHighestIdx == null ? get_lastIndex(sub) : nextHighestIdx;
    if (0 <= inductionVariable)
      do {
        var idx_0 = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        replace(sub, idx_0, reorder$lambda_0(before, idx_0, step));
      }
       while (0 <= inductionVariable);
    tmp$ret$2 = _this__u8e3s4.q1(pos + 1 | 0);
  }
  var after = tmp$ret$2;
  var tmp1_elvis_lhs = before == null ? null : before.k8v();
  var tmp_3 = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
  var tmp3_elvis_lhs = after == null ? null : after.k8v();
  var avg = (tmp_3 + (tmp3_elvis_lhs == null ? 1.0 : tmp3_elvis_lhs)) / 2;
  _this__u8e3s4.y3(toIdx, _this__u8e3s4.z3(fromIdx).l8v(avg));
}
function get_order(_this__u8e3s4) {
  var tmp0 = ensureNotNull(get_serializableProperties(_this__u8e3s4));
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.first' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.k20() === 'order') {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    throw NoSuchElementException().o('Array contains no element matching the predicate.');
  }
  var tmp = tmp$ret$1;
  return isInterface(tmp, SerializableProperty()) ? tmp : THROW_CCE();
}
function replace(_this__u8e3s4, idx, new_0) {
  _this__u8e3s4.b2(idx, new_0(_this__u8e3s4.q1(idx)));
}
function reorder$lambda(it) {
  return it.l8v(coerceIn(it.k8v(), 1.0E-6, 0.999999));
}
function reorder$lambda_0($before, $idx, $step) {
  return (it) => it.l8v($before.k8v() + ($idx + 1 | 0) * $step);
}
//region block: exports
export {
  compareTo_0 as compareTobo60qch4pcdz,
  Reorderable as Reorderable3ea4zkahqiq6k,
  createReorderMods as createReorderModssndd63zi2ijm,
};
//endregion

//# sourceMappingURL=Reorderable.mjs.map
